import { render, staticRenderFns } from "./VerifyMobileSvg.vue?vue&type=template&id=127a903e&scoped=true&"
var script = {}
import style0 from "./VerifyMobileSvg.vue?vue&type=style&index=0&id=127a903e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a903e",
  null
  
)

export default component.exports